import { getCms } from "@/lib/cms";
import Client, { BASE_FILTER_NEWS, BASE_PAGE, BASE_SORT } from "./client";
import { PageAppRouter } from "@/@types/page";

export interface NewsEventProps {
  searchParams: PageAppRouter["searchParams"];
  params: PageAppRouter["params"];
  social_media_link: string;
  social_media_title: string;
}

export default async function NewsEvent(props: NewsEventProps) {
  const lang = props.params.locale ?? "en";
  const _category = props.searchParams.category;
  const sort = props.searchParams.sort ?? 'custom_date:desc';
  const page = props.params.page ?? 1;

  const thumbnailNewsResponse = await getCms("new-and-events", lang, {
    pagination: {
      limit: 1,
    },
    pLevel: 2,
    filters: {
      ...(_category && { category: { $eq: _category } }),
      is_thumbnail: { $eq: true },
    },
    sort: "custom_date:desc",
  })

  const newsEventResponse = await getCms("new-and-events", lang, {
    ...BASE_FILTER_NEWS,
    sort: sort,
    pagination: {
      pageSize: 5,
      page: Number(page || 1),
    },
    filters : {
      ...BASE_FILTER_NEWS.filters,
      id : {
        $ne: thumbnailNewsResponse?.[0]?.id,
      }
    },
    pLevel: 2,
  })

  const thumbnailNews = thumbnailNewsResponse ?? [];
  const [listNews, metaNews] = newsEventResponse ?? [];

  return (
    <Client
      news={{
        data: listNews ?? [],
        meta: metaNews ?? { pagination: { pageCount: 1, page: 1 } },
      }}

      social_media_link={props.social_media_link}
      social_media_title={props.social_media_title}
      thumbnailArticles={{
        data: thumbnailNews?.[0],
        meta: thumbnailNews?.[1],
      }}
    />
  );
}
